/**
 * Retries a lazy import with exponential backoff and better error handling
 */
export function retryLazy<T>(
  importFn: () => Promise<T>,
  retries = 3,
  delay = 1000
): Promise<T> {
  return new Promise((resolve, reject) => {
    const attempt = (attemptNumber: number) => {
      importFn()
        .then(resolve)
        .catch((error) => {
          console.error(`Lazy load attempt ${attemptNumber} failed:`, error);
          
          if (attemptNumber < retries) {
            const backoffDelay = delay * Math.pow(2, attemptNumber - 1);
            console.log(`Retrying in ${backoffDelay}ms...`);
            setTimeout(
              () => attempt(attemptNumber + 1),
              backoffDelay
            );
          } else {
            console.error('All retry attempts failed:', error);
            reject(new Error(`Failed to load module after ${retries} attempts: ${error.message}`));
          }
        });
    };

    attempt(1);
  });
}